var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%","overflow":"hidden"}},[_c('el-image',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.pictureImg,"fit":"cover"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }